import axios from 'axios';
import { API_KEY, API_BASE_URL } from '../../constants';
import { SignUpInfo, ToolState, SignUpInfoWithResults } from '../../models';

export const buildRequestHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'X-Api-Key': `${API_KEY}`
  }
}

export const post = async (url : string, method : string, ...args : object[]) => (
  await axios.post(`${API_BASE_URL}${url}`, ...args)
)

export const get = async (url : string, method : string, ...args : object[]) => (
  await axios.get(`${API_BASE_URL}${url}`, ...args)
)

export const writeRequest = async (url : string, method : string, data : object) => {
  const params = {headers: buildRequestHeaders()}
  const response = await post(url, method, data, params)
  return response.data
}

export const readRequest = async (url : string, method : string) => {
  const params = {headers: buildRequestHeaders()}
  const response = await get(url, method, params)
  return response.data
}

export const signUp = async (info : SignUpInfo, toolState: ToolState) => {
  const infoWithResults : SignUpInfoWithResults = {
     name: info.name,
     email: info.email,
     simulatorResults: {
       allocation: toolState.allocation,
       capitalFund: toolState.capitalFund,
       digitalFund: toolState.digitalFund,
       duration: toolState.duration,
       highCaseOutcome: toolState.highCaseOutcome,
       lowCaseOutcome: toolState.lowCaseOutcome,
       mediumCaseOutcome: toolState.mediumCaseOutcome,
       lumpSum: toolState.lumpSum,
       monthlyContribution: toolState.monthlyContribution,
       graphData: null as any,
       graphFilter: null as any
     }
  };

  return writeRequest('/marketing/toolsignup', 'post', infoWithResults);
}